/**
 * The other calls I am on RIGHT NOW.
 *
 * This is what keeps "Merge" honest. Merging needs a second call to merge with,
 * and the only moment there usually is one is during a consultative transfer —
 * so the menu asks first and simply does not offer the option when the answer is
 * "there is no other call". A permanently visible Merge that fails on click is
 * the surface this wave exists to remove.
 */
import { useQuery } from '@tanstack/react-query';
import { callsApi, type ActiveCall } from '../data/callsApi';
import { CALL_KEYS } from '../data/queryKeys';

export function useOtherActiveCalls(callId: string, enabled: boolean): ActiveCall[] {
  const query = useQuery({
    queryKey: CALL_KEYS.active(callId),
    queryFn: () => callsApi.activeCalls(callId).then((page) => page.calls),
    enabled: enabled && callId !== '',
    /* Asked when the menu opens, and a call I hung up two seconds ago must not
       still be offered — so this answer is never reused. */
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });
  return query.data ?? [];
}

/** "Ganesh Kumar" · "Ganesh Kumar and 2 others" · "Call". */
export function labelForActiveCall(call: ActiveCall): string {
  const first = call.others[0];
  if (first === undefined) return 'Call';
  if (call.others.length === 1) return first.displayName;
  return `${first.displayName} and ${call.others.length - 1} others`;
}
